import { render, staticRenderFns } from "./confirm_dialog.vue?vue&type=template&id=112240f2&scoped=true"
import script from "./confirm_dialog.vue?vue&type=script&lang=ts"
export * from "./confirm_dialog.vue?vue&type=script&lang=ts"
import style0 from "./confirm_dialog.vue?vue&type=style&index=0&id=112240f2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "112240f2",
  null
  
)

export default component.exports